＂<template>
  <div>
    <el-input
      class="head-search list clearable"
      clearable
      :placeholder="referer == 'list' ? 'リスト名/インフルエンサー名で検索' : 'レポート名/ユーザー名で検索'"
      v-model="search_word"
      @input="sortSuggest($event)"
      @focus="suggest_show = true"
      @blur="suggest_on ? '' : (suggest_show = false) & (suggest_hover = -1)"
      @keydown.up.native="suggestHover('up', 'influencer-box')"
      @keydown.down.native="suggestHover('down', 'influencer-box')"
      @keypress.enter.native="suggestEnter(suggest_hover)"
      id="head-search"
    ></el-input>
    <div class="request-pr-form-suggest sort" id="influencer-box" v-if="suggest_show && search_word != ''">
      <div v-for="(suggest, index) in suggests" :key="suggest.id" class="suggest-box-wrap">
        <div v-if="suggest.type == 'title'" class="suggest-box-title">
          <font-awesome-icon :icon="['far', suggest.icon]" style="margin-right: 3px;" />
          {{ suggest.value }}
        </div>
        <div
          class="request-pr-form-suggest-box"
          style="padding: 15px 20px;"
          v-else-if="suggest.type == 'over'"
          :class="suggest_hover == index ? 'hover' : ''"
          @mouseover="keydown_hover ? (suggest_on = true) : ((suggest_hover = index), (suggest_on = true))"
          @mouseleave="suggest_on = false"
          @click="suggestEnter(index)"
        >
          <div style="color:#666"><font-awesome-icon :icon="['fas', 'search']" style="margin-right: 10px;" />{{ search_word }}</div>
          <div class="suggest-box-guide border">
            <span
              >該当リストを表示
              <font-awesome-icon :icon="['far', 'arrow-turn-down-left']" style="margin-left: 3px;" />
            </span>
          </div>
        </div>
        <div
          class="request-pr-form-suggest-box sort"
          v-else
          v-show="search_word != '' || suggest_loading"
          :class="suggest_hover == index ? 'hover' : ''"
          @mouseover="keydown_hover ? (suggest_on = true) : ((suggest_hover = index), (suggest_on = true))"
          @mouseleave="suggest_on = false"
          @click="suggestEnter(index)"
        >
          <div style="position:relative; margin-right:10px">
            <el-image :src="suggest.picture_url" class="request-pr-form-suggest-image">
              <div slot="error" class="data-table-profile-noimg" v-if="suggest.type == 'influencer'">NO<br />IMAGE</div>
              <div slot="error" class="data-table-profile-noimg" v-else>
                <font-awesome-icon :icon="['fal', 'list']" />
              </div>
            </el-image>
            <div class="suggest-sns-type" :class="suggest.sns_type"><font-awesome-icon :icon="['fab', suggest.sns_type]" /></div>
          </div>
          <div>
            <div class="flex-row">
              <div v-html="$options.filters.fontBold(suggest.suggest_name, search_word)"></div>
              <img src="../../assets/badge.png" style="width:10px; height:10px; margin-left:3px" v-show="suggest.badge == '1'" />
            </div>
            <div style="color:#aaa" v-if="suggest.type == 'influencer'">{{ suggest.list_count }}件のリスト</div>
            <div style="color:#aaa" v-else-if="suggest.type == 'list'">{{ suggest.influencer_num }}名のインフルエンサー</div>
          </div>
          <div v-show="suggest_hover == index" class="suggest-box-guide">
            <span v-if="suggest.type == 'list'">
              リストに移動
              <font-awesome-icon :icon="['far', 'arrow-turn-down-left']" style="margin-left: 3px;" />
            </span>
            <span v-else-if="suggest.type == 'influencer'">
              該当リストを表示
              <font-awesome-icon :icon="['far', 'arrow-turn-down-left']" style="margin-left: 3px;" />
            </span>
          </div>
        </div>
      </div>
      <div class="request-pr-form-suggest-box nolist" v-if="suggests.length == 0 && search_word">
        <div class="loader--mini blue" v-if="suggest_loading"></div>
        <span v-else>該当するリストはありません</span>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const sortSuggestAPI = root + "/api/list/sort_suggest";

export default {
  name: "sortSuggest",
  props: ["referer"],
  components: {},
  data() {
    return {
      search_word: "",
      suggests: [],
      nolist: false,
      suggest_loading: false,
      suggest_show: false,
      suggest_hover: -1,
      suggest_on: false,
      keydown_hover: false,
      requestId: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  created() {},
  mounted() {},
  methods: {
    sortSuggest() {
      this.suggests = [];
      this.nolist = false;
      this.suggest_loading = true;
      this.suggest_show = true;
      this.suggest_hover = -1;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(sortSuggestAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            keyword: this.search_word,
          },
        })
        .then((response) => {
          this.suggests = response.data.suggests;
          this.nolist = response.data.nolist;
          this.suggest_loading = false;
        });
    },
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover -= 1;
          if (this.suggests[this.suggest_hover].type == "title") this.suggest_hover -= 1;
        }
      } else if (type == "down") {
        if (this.suggest_hover == this.suggests.length - 1) {
          this.suggest_hover += 0;
        } else {
          this.suggest_hover += 1;
          if (this.suggests[this.suggest_hover].type == "title") this.suggest_hover += 1;
        }
      }
      this.keydown_hover = true;
      var target = document.getElementById(position);
      var suggest_position = 51;
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    suggestEnter(index) {
      var target = this.suggests[index];
      if ((index == -1 || target.type == "over") && !this.nolist) {
        this.$emit("searchList", this.search_word);
      } else if (target.type == "list") {
        this.$router.push({
          name: "listDetail",
          params: {
            list_id: target.list_id,
          },
        });
      } else if (target.type == "influencer") {
        this.$emit("searchListByInfluencer", target);
      }
      this.suggest_show = false;
      this.suggest_on = false;
      this.suggest_hover = -1;
      document.getElementById("head-search").blur();
    },
  },
  watch: {},
  filters: {
    fontBold(value, search_word) {
      return value.replace(new RegExp(search_word, "ig"), (search_word) => '<span class="data-table-th-highlight">' + search_word + "</span>");
    },
  },
};
</script>
